import type { Product } from '@mc/api'
import { BOGO_PROPS } from '../../lib/constants'
import { trackGoldStandardPurchaseClick } from '../shared/goldStandardPurchaseClick'

type Location =
  | (typeof BOGO_PROPS.OFFER_PAGE.LOCATION)[keyof typeof BOGO_PROPS.OFFER_PAGE.LOCATION]
  | typeof BOGO_PROPS.PROMO_MODAL.LOCATION
  | typeof BOGO_PROPS.PROMO_BANNER.LOCATION

// All BOGO CTAs that use this helper navigate to quiz/checkout (middle funnel),
// so fire the gold-standard "Purchase Click".
export const trackBogoCtaClicked = ({
  action,
  href,
  location,
  annualPass,
}: {
  action: string
  href: string
  location: Location
  annualPass?: Product | null
}) =>
  trackGoldStandardPurchaseClick({
    action,
    location,
    href,
    annualPass,
  })
